import { render, staticRenderFns } from "./TextIcons.vue?vue&type=template&id=9395d288"
import script from "./TextIcons.vue?vue&type=script&lang=js"
export * from "./TextIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports